import { Image, Space } from "antd";

export type PayCardProps = {
  itemWidth?: string;
  itemHeight?: string;
};

export const PayCard: React.FC<PayCardProps> = ({
  ...props
}) => {
  const { itemWidth, itemHeight } = props;

  return (
    <div className="">
      <Space size={[9, 8]} wrap className="justify-center">
        {
          [
            {
              src: '/img/payImg/visa.png',
              alt: 'visa'
            },
            {
              src: '/img/payImg/Mastercard.png',
              alt: 'Mastercard'
            },
            {
              src: '/img/payImg/Maestro.png',
              alt: 'Maestro'
            },
            {
              src: '/img/payImg/American Express.png',
              alt: 'American Express'
            },
            {
              src: '/img/payImg/discover.png',
              alt: 'discover'
            },
            {
              src: '/img/payImg/diners club.png',
              alt: 'diners club'
            },
            {
              src: '/img/payImg/paypal.png',
              alt: 'paypal'
            },
            {
              src: '/img/payImg/stripe.png',
              alt: 'stripe'
            },
            {
              src: '/img/payImg/Affirm.png',
              alt: 'Affirm'
            },
            {
              src: '/img/payImg/apple pay.png',
              alt: 'apple pay'
            },
            {
              src: '/img/payImg/google pay.png',
              alt: 'google pay'
            },
            {
              src: '/img/payImg/venmo.png',
              alt: 'venmo'
            },
            {
              src: '/img/payImg/Amazon Pay.png',
              alt: 'Amazon Pay'
            },
            {
              src: '/img/payImg/klarna.png',
              alt: 'klarna'
            },
            {
              src: '/img/payImg/Link.png',
              alt: 'Link'
            },
            {
              src: '/img/payImg/Cash APP Pay.png',
              alt: 'Cash APP Pay'
            }
          ].map((item, index) => (<Image
            key={item.alt}
            src={item.src}
            alt={item.alt}
            preview={false}
            style={{ width: itemWidth || '32px', height: itemHeight || '20px' }}
            className='rounded-[2px]'
          />))
        }
      </Space>
    </div>
  );
};
